export const NOTIFICATION_CONTAINER_ID = 'notification-container-id';

export const EXTRA_ROOM = 25;

export const NOTIFICATION_LOADED_MESSAGE = 'NOTIFICATION_LOADED';
export const NOTIFICATION_SHOW_MAIN = 'NOTIFICATION_SHOW_MAIN';
